import { useState } from 'react'
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '@context/AuthContext'
import './AdminLayout.scss'

const PAGE_TITLES = {
  '/admin': 'Dashboard',
  '/admin/products': 'Produse',
  '/admin/products/new': 'Produs nou',
  '/admin/orders': 'Comenzi',
}

function getPageTitle(pathname) {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname]
  if (pathname.startsWith('/admin/products/') && pathname.includes('/edit')) return 'Editare produs'
  if (pathname.startsWith('/admin/orders/')) return 'Detalii comandă'
  return 'Admin'
}

export default function AdminLayout() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const pageTitle = getPageTitle(location.pathname)

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  const closeSidebar = () => setSidebarOpen(false)

  return (
    <div className="admin-layout">
      <button
        type="button"
        className="admin-layout__burger"
        aria-label="Meniu"
        onClick={() => setSidebarOpen(true)}
      >
        <span />
        <span />
        <span />
      </button>

      <div
        className={`admin-layout__overlay ${sidebarOpen ? 'admin-layout__overlay--open' : ''}`}
        onClick={closeSidebar}
        aria-hidden
      />

      <aside className={`admin-layout__sidebar ${sidebarOpen ? 'admin-layout__sidebar--open' : ''}`}>
        <div className="admin-layout__logo">Miss Lemon</div>
        <nav className="admin-layout__nav">
          <NavLink to="/admin" end onClick={closeSidebar} className={({ isActive }) => (isActive ? 'admin-layout__link admin-layout__link--active' : 'admin-layout__link')}>
            Dashboard
          </NavLink>
          <NavLink to="/admin/products" onClick={closeSidebar} className={({ isActive }) => (isActive ? 'admin-layout__link admin-layout__link--active' : 'admin-layout__link')}>
            Produse
          </NavLink>
          <NavLink to="/admin/orders" onClick={closeSidebar} className={({ isActive }) => (isActive ? 'admin-layout__link admin-layout__link--active' : 'admin-layout__link')}>
            Comenzi
          </NavLink>
        </nav>
        <button type="button" className="admin-layout__logout" onClick={handleLogout}>
          Deconectare
        </button>
      </aside>

      <div className="admin-layout__main">
        <header className="admin-layout__header">
          <h1 className="admin-layout__title">{pageTitle}</h1>
          <div className="admin-layout__user">
            <span className="admin-layout__user-name">
              {user?.firstName} {user?.lastName}
            </span>
            <span className="admin-layout__user-role">{user?.role}</span>
          </div>
        </header>
        <div className="admin-layout__content">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
